export default "__VITE_ASSET__9kBTUqaINCHDANxrI10WCw__ 480w, __VITE_ASSET__qZZZ7EOcQU0bnm2SE9d1Ig__ 768w, __VITE_ASSET__C$4kQWR6NkPB83QJdL0WCQ__ 1200w";